import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_ME_PATH_KEY } from '@/swagger/constants/anagraphics-keys';

export const API_GET_EMPLOYEES_ME = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_ME_PATH_KEY, {
    organizationId,
  });
};
